/**
 * 支付管理 支付配置信息
 */
<template>
  <div>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/shop/addActive.vue